export default __webpack_public_path__ + "static/logo2-53b1aa15d35d83112c8b3aec1d44ffe6.svg";